import styles from './PlayIcon.less'

const PlayIcon = ()=>(
	<div className={ styles["player-btn"]}   >
	  <div className={ styles["circle-icon"]}></div>
	  <div className={ `${styles["wrapper"]} ${styles["right"]}` }>
	        <div className={ `${styles["circleProgress"]} ${styles["rightcircle"]}` }></div>
	  </div>
	    <div className={ `${styles["wrapper"]} ${styles["right"]}` }>
	        <div className={ `${styles["circleProgress"]} ${styles["rightcirclea"]}` }></div>
	    </div>
	    <div className={ `${styles["wrapper"]} ${styles["left"]}` }>
	        <div className={ `${styles["circleProgress"]} ${styles["leftcircle"]}` }></div>
	    </div>
	    <div className={ `${styles["wrapper"]} ${styles["left"]}` }>
	        <div className={ `${styles["circleProgress"]} ${styles["leftcirclea"]}` }></div>
	    </div>
	 </div>
)

export default PlayIcon